import { render } from "./product-card-sample.vue?vue&type=template&id=676ccb66"
import script from "./product-card-sample.vue?vue&type=script&lang=js"
export * from "./product-card-sample.vue?vue&type=script&lang=js"

import "./product-card-sample.vue?vue&type=style&index=0&id=676ccb66&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__